module.exports = __webpack_public_path__ + "static/media/iconFemale.2420185f.svg";